const bestSeller = () => {
  const width = $(window).width();
  function initSlick() {
    const sliderSelector = `.best-seller .best-seller-container`;
    if (width <= 560) {
      // mobile screens
      $(sliderSelector).slick({
        arrows: false,
        vertical: false,
        dots: true,
        draggable: true,
        infinite: false,
        centerMode: false,
        adaptiveHeight: true,
        slidesToShow: 1,
        rows: 2,
        slidesPerRow: 1,
        verticalSwiping: false,
      });
    }
  }
  initSlick();
}; // Mobile/tab Only Slider

export default bestSeller;
